export const constants = {
  LM_KEY: 'admin-living-meaningfully',
  LM_AUTH: 'LM-a',
  LM_USER: 'LM-u',
  ENCRYPTION_KEY: 'JaNdRgUkXp2s5v8y/A?D(G+KbPeShVmY',
  TABLE_ROWS: 25,
  HOME_ROUTE: '/app/dashboard',
  DEFAULT_ROUTE: '/landing',
  DEFAULT_PAGE_SIZE: 7,
  AUTH_ROUTE: '/form-fields/login',
};

export const StrongPasswordRegx: RegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+{}\[\]:;<>,.?~\\-]).{8,}$/;
export const EmailPattern: RegExp = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
export const GenericPattern: RegExp = /^[a-zA-Z-]*$/;
export const GenericPatternWithSpace: RegExp = /^[a-zA-Z\d\-_.\s]*$/;
export const URLPattern: RegExp = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b[-a-zA-Z0-9()@:%_+.~#?&\/=]*$/;
export const PhoneNumberPattern: RegExp = /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
